import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
});

/**
 * Lightweight fetch-like wrapper around axios `api`.
 * Usage: apiFetch("/auri/config") or apiFetch("/api/auri/config") — both work.
 */
export async function apiFetch(url, { method = "GET", body = null, headers = {} } = {}) {
  const cleaned = url.replace(/^\/api\/?/, "/");
  try {
    const cfg = { method, url: cleaned, headers };
    if (body !== null && method !== "GET") cfg.data = body;
    const res = await api.request(cfg);
    return res.data;
  } catch (err) {
    const detail = err?.response?.data?.detail || err?.message || "Request failed";
    throw new Error(formatApiError(detail));
  }
}

api.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" ? localStorage.getItem("altura_token") : null;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Referral attribution — auto-inject the captured ?ref=CODE into any
  // public lead-creating POST body if one exists and the body doesn't
  // already contain a `referral_code`. Keeps the wiring in a single place
  // so we don't have to touch every form component.
  try {
    const method = (config.method || "").toLowerCase();
    const url = (config.url || "").toString();
    const isPublicPost = method === "post" && url.startsWith("/public/") && !url.includes("increment-download") && !url.includes("resources/recommend");
    if (isPublicPost && typeof window !== "undefined") {
      const ref = window.sessionStorage.getItem("altura_ref_code");
      if (ref && config.data && typeof config.data === "object" && !config.data.referral_code) {
        config.data = { ...config.data, referral_code: ref };
      }
    }
  } catch (_) { /* noop */ }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // token invalid — clear and let router handle
      localStorage.removeItem("altura_token");
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
